/* eslint-disable camelcase */
import React from 'react';
import { isEmpty as _isEmpty, replace, startsWith } from 'lodash';
import mmtz from 'moment-timezone';
import moment from 'moment';
import { convertDateToISOString, logErrorToConsole } from './util';
import i18n from 'src/i18n.js';
const t = (key) => i18n.t(key);

export const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

export const dateTimeFormatter = (data, condition) => {
    let hour;
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `${month}`;
    const year = a.getFullYear();
    const h = a.getHours();
    const ampm = h >= 12 ? ' pm' : ' am';
    const AMPM = h >= 12 ? ' PM' : ' AM';
    hour = h % 12;
    hour = hour || 12;
    let min = a.getMinutes();
    min = min.toString().length == 2 ? min : `0${min}`;
    let res;
    if (condition) {
        res = (
            <span>
                {`${month}/${dt}/${year}`} {`${hour}:${min}${AMPM}`}
            </span>
        );
    } else {
        res = (
            <span>
                {`${month}/${dt}/${year}`}
                <br /> {`${hour}:${min}${ampm}`}
            </span>
        );
    }
    return res;
};

export const changeDateFormat = (data) => {
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `${month}`;
    const year = a.getFullYear();
    const res = `${month}/${dt}/${year}`;
    return res;
};

export const convertToMMddYYYY = (data) => {
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `${month}`;
    const year = a.getFullYear();
    const res = `${month}/${dt}/${year}`;
    return res;
};
export const convertToMMddYYYYDateFormat = (data) => {
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `0${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `${month}`;
    const year = a.getFullYear();
    const res = `${month}/${dt}/${year}`;
    return res;
};
export const convertToMMddYYYYForRVM = (data) => {
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `0${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `0${month}`;
    const year = a.getFullYear();
    const res = `${month}/${dt}/${year}`;
    return res;
};
export const convertToYYYYMMdd = (data) => {
    if (typeof data === 'string' && data.indexOf('-') !== -1) {
        return data;
    } else {
        const a = new Date(data);
        let dt = a.getDate();
        dt = dt.toString().length == 2 ? dt : `0${dt}`;
        let month = parseInt(a.getMonth()) + 1;
        month = month.toString().length == 2 ? month : `0${month}`;
        const year = a.getFullYear();
        const res = `${year}-${month}-${dt}`;
        return res;
    }
};

export const convertToYYYYMMddforSMS = (data) => {
    {
        const a = new Date(data);
        let dt = a.getDate();
        dt = dt.toString().length == 2 ? dt : `0${dt}`;
        let month = parseInt(a.getMonth()) + 1;
        month = month.toString().length == 2 ? month : `0${month}`;
        const year = a.getFullYear();
        const res = `${month}/${dt}/${year}`;
        return res;
    }
};

export const convertToSMSDateFormatYYYYMMdd = (date) => {
    let res;
    try {
        //date 2020-12-18T11:45:04.000Z
        const dateAlone = date.substring(0, 10);
        const a = new Date(dateAlone);
        let dt = a.getDate();
        dt = dt.toString().length == 2 ? dt : `0${dt}`;
        let month = parseInt(a.getMonth()) + 1;
        month = month.toString().length == 2 ? month : `0${month}`;
        let year = a.getFullYear();
        res = `${month}/${dt}/${year}`;
        //res = dateAlone.replaceAll('-', '/');
        return res;
    } catch (e) {
        logErrorToConsole('Date error', e);
    }
    return res;
};
export const getTomorrowDate = (
    upcomingBusinessDaysAndHolidays = [],
    surgery
) => {
    const today = new Date();
    const tomorrow = moment(today).startOf('day').add(1, 'days').toDate();
    if (surgery) {
        let checkDate = new Date();
        checkDate.setDate(checkDate.getDate() + 1);
        const dateSet = new Set(
            upcomingBusinessDaysAndHolidays?.map(
                (item) => new Date(item).toISOString().split('T')[0]
            )
        );
        while (
            dateSet?.has(checkDate.toISOString().split('T')[0]) ||
            isWeekend(checkDate)
        ) {
            checkDate.setDate(checkDate.getDate() + 1);
        }

        return new Date(checkDate); // Return the date in YYYY-MM-DD format
    }

    return tomorrow;
};
export const isWeekend = (date) => {
    const day = date.getDay();
    return day === 0 || day === 6;
};
export const convertToISO = (input) => {
    if (input.toString() == '') return input;

    if (input.toString().indexOf('GMT') > -1) {
        var a = new Date(input.toString());

        let dt = a.getTimezoneOffset() > 0 ? a.getDate() + 1 : a.getDate();

        dt = dt.toString().length == 2 ? dt : `${dt}`;

        let month = parseInt(a.getMonth()) + 1;
        month = month.toString().length == 2 ? month : `${month}`;

        const year = a.getFullYear();
        return `${year}-${month}-${dt}`;
    }
    const arrInput = input.toString().split('/');
    return `${arrInput[2]}-${arrInput[0]}-${arrInput[1]}`;
};

export function convertToUserPrefTZTimeOrDate(
    date,
    userPrefTimeZoneOffset,
    userPrefTZCurrentDate,
    userProfileData
) {
    let timeOrDate;
    try {
        const dateWithUserPrefTZ = gmtToLocalDateTime(
            userProfileData,
            new Date(date).toISOString()
        );
        // dateWithUserPrefTZ 2020-12-10T13:07:10.000Z
        if (
            isDateTodayForUserPrefTZ(
                userPrefTimeZoneOffset,
                userPrefTZCurrentDate,
                dateWithUserPrefTZ
            )
        ) {
            timeOrDate = getTimeInAMorPM(dateWithUserPrefTZ.substring(11, 19));
        } else {
            timeOrDate = DateConvertorInMMDDYYYY(dateWithUserPrefTZ);
        }
    } catch (e) {
        logErrorToConsole('Date error', e);
    }
    return timeOrDate;
}

/**
 *
 * @param {*19:39:12 } time
 */
function getTimeInAMorPM(time) {
    let strTime;
    try {
        const timeArr = time.split(':');
        var hours = timeArr[0];
        var minutes = parseInt(timeArr[1]); // parseInt is required otherwise sms received at 12:00 time will be dispalyeda as 12:000
        var ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    } catch (e) {
        logErrorToConsole('Date error', e);
    }
    return strTime;
}

export function isDateTodayForUserPrefTZ(
    userPrefTimeZoneOffset,
    userPrefTZCurrentDate,
    givenDate
) {
    try {
        //userPrefTZCurrentDate will be like this 2020-12-18T04:21:15.923Z
        let todaysDate = userPrefTZCurrentDate.substring(0, 10);
        let ipDate = givenDate.substring(0, 10);
        const todaysDateArr = todaysDate.split('-');
        const ipDateArr = ipDate.split('-');
        return (
            todaysDateArr[0] === ipDateArr[0] && //year
            todaysDateArr[1] === ipDateArr[1] && //month
            todaysDateArr[2] === ipDateArr[2]
        ); //date
    } catch (e) {
        return false;
    }
}

/**
 * To get the timezone offset like +5.5 (+05:30)
 * @param {*} userProfileData
 */
export function getTimeZoneOffset(userProfileData) {
    let finalOffset;
    try {
        if (
            userProfileData &&
            userProfileData.personalUserSettings &&
            userProfileData.personalUserSettings.userInterfaceName &&
            userProfileData.personalUserSettings.userInterfaceName.split(' ')[0]
                .length > 5
        ) {
            const offset =
                userProfileData.personalUserSettings.userInterfaceName
                    .split(' ')[0]
                    .substring(4, 10);
            const hrOffset = offset && parseInt(offset);
            const minOffset = offset && parseInt(offset.substring(4, 6)) / 60;
            if (hrOffset >= 0) {
                finalOffset = hrOffset + minOffset;
            } else {
                finalOffset = hrOffset + -minOffset;
            }
        } else {
            finalOffset = 0.0;
        }
    } catch (e) {
        logErrorToConsole('Date error', e);
    }
    return finalOffset;
}
/**
 * To get current time related to user pref timezone
 * @param {*} offset
 */
export function getDateFromOffset(offset) {
    let offsetTime = null;
    try {
        let d = new Date();
        let utc = d.getTime() + d.getTimezoneOffset() * 60000;
        let nd = new Date(utc + 3600000 * offset);
        let date = new Date(nd);
        offsetTime = getDateInYYYYMMDD(date);
    } catch (e) {
        logErrorToConsole('Date error', e);
    }
    return offsetTime;
}

function getDateInYYYYMMDD(dateObj) {
    let formattedDate;
    try {
        let dt = dateObj.getDate();
        dt = dt.toString().length == 2 ? dt : `0${dt}`;
        let month = parseInt(dateObj.getMonth()) + 1;
        month = month.toString().length == 2 ? month : `0${month}`;
        const year = dateObj.getFullYear();
        formattedDate = `${year}-${month}-${dt}`;
    } catch (e) {
        formattedDate = dateObj;
    }
    return formattedDate;
}

//Add current time to a provided date
export const addCurrentTime = (date) => {
    const now = new Date();
    date.setHours(
        now.getHours(),
        now.getMinutes(),
        now.getSeconds(),
        now.getMilliseconds()
    );
    return date;
};
export const getModifiedDuration = (data) => {
    const today = new Date();
    const a = new Date(data);
    const Difference_In_Time =
        (today.getTime() - a.getTime()) / (1000 * 3600 * 24);
    return Difference_In_Time.toFixed(0);
};

export const convertToPersonalMMddYYYY = (data) => {
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `${month}`;
    const year = a.getFullYear();
    const res = `${month}/${dt}/${year}`;
    return res;
};

let inputdate;
export const removeDateExtraZero = (data) => {
    inputdate = data.split('/');
    const dt =
        inputdate[1].length === 2 && inputdate[1].charAt(0) !== '0'
            ? inputdate[1]
            : `${inputdate[1].charAt(1)}`;
    return `${inputdate[0]}/${dt}/${inputdate[2]}`;
};

export const DateConvertorInMMDDYYYY = (data) => {
    //This function can be used if we are facing
    //  one day prior date issue in Eastern Day Light Time.
    // It accepts input date as 2020-06-09 or 2020-06-09T00:00:00.000+0000 or 2020-06-09T00:00:00Z
    // and will return date as 06/09/2020

    if (data.indexOf('-') === -1) {
        inputdate = data.split('/');
    } else {
        inputdate = data.split('-');
    }

    const date = inputdate[2].charAt(0) + inputdate[2].charAt(1);
    const dt =
        date.toString().length === 2 && date.toString().charAt(0) !== '0'
            ? date
            : `${date.toString().charAt(1)}`;
    const month =
        inputdate[1].toString().length === 2 &&
        inputdate[1].toString().charAt(0) !== '0'
            ? inputdate[1]
            : `${inputdate[1].toString().charAt(1)}`;
    const year = inputdate[0];

    let slicedMonth;
    let slicedDate;
    let slicedYear;
    const res = `${month}/${dt}/${year}`;
    var indexOFT = res.indexOf('T');
    var indexOfZ = res.indexOf('Z');
    var indexOfZero = res.lastIndexOf('0');
    if (indexOFT > -1 && indexOfZ > -1) {
        slicedMonth = res.slice(0, 2);
        slicedDate = res.slice(3, 5);
        slicedYear = res.slice(res.lastIndexOf('/') + 1);
        return `${slicedMonth}/${slicedDate}/${slicedYear}`;
    } else if (indexOFT > -1 && indexOfZero > -1) {
        slicedMonth = res.slice(0, 2);
        slicedDate = res.slice(3, 5);
        slicedYear = res.slice(res.lastIndexOf('/') + 1);
        return `${slicedMonth}/${slicedDate}/${slicedYear}`;
    } else {
        return res;
    }
};

export const getFullDayName = (day) => {
    switch (day) {
        case 0:
            return t('calendar.weekdaysFullName.sunday');
        case 1:
            return t('calendar.weekdaysFullName.monday');
        case 2:
            return t('calendar.weekdaysFullName.tuesday');
        case 3:
            return t('calendar.weekdaysFullName.wednesday');
        case 4:
            return t('calendar.weekdaysFullName.thursday');
        case 5:
            return t('calendar.weekdaysFullName.friday');
        case 6:
            return t('calendar.weekdaysFullName.saturday');
        default:
            return '';
    }
};

export const getShortDayName = (day) => {
    switch (day) {
        case 0:
            return t('calendar.weekdaysShortName.sunday');
        case 1:
            return t('calendar.weekdaysShortName.monday');
        case 2:
            return t('calendar.weekdaysShortName.tuesday');
        case 3:
            return t('calendar.weekdaysShortName.wednesday');
        case 4:
            return t('calendar.weekdaysShortName.thursday');
        case 5:
            return t('calendar.weekdaysShortName.friday');
        case 6:
            return t('calendar.weekdaysShortName.saturday');
        default:
            return '';
    }
};

export const getShortMonthName = (year) => {
    switch (year) {
        case 0:
            return t('calendar.months.jan');
        case 1:
            return t('calendar.months.feb');
        case 2:
            return t('calendar.months.mar');
        case 3:
            return t('calendar.months.apr');
        case 4:
            return t('calendar.months.may');
        case 5:
            return t('calendar.months.jun');
        case 6:
            return t('calendar.months.jul');
        case 7:
            return t('calendar.months.aug');
        case 8:
            return t('calendar.months.sep');
        case 9:
            return t('calendar.months.oct');
        case 10:
            return t('calendar.months.nov');
        case 11:
            return t('calendar.months.dec');
        default:
            return '';
    }
};
//format Tuesday, 10/03/2020, 8:00PM
export const getDateFormat = (sendOnDate) => {
    if (sendOnDate) {
        const date = new Date(sendOnDate);
        const day = date.getDay();
        const dateFormat = convertToMMddYYYY(sendOnDate);
        const time = date.toLocaleTimeString();

        return `${day}, ${dateFormat}, ${time}`;
    } else return '';
};

export const convertDateToPrefTZ = (timeZone, selectedDate) => {
    let tz = 'America/New_York';
    switch (timeZone) {
        case 'Eastern Standard Time':
            tz = 'America/New_York';
            break;
        case 'Central Standard Time':
            tz = 'America/Chicago';
            break;
        case 'Mountain Standard Time':
            tz = 'America/Phoenix';
            break;
        case 'Pacific Standard Time':
            tz = 'America/Los_Angeles';
            break;
        default:
            tz = 'America/New_York';
    }

    var convertedDate = mmtz.tz(selectedDate, tz).format();
    var selectedYear = selectedDate.getFullYear();
    var selectedMonth =
        parseInt(selectedDate.getMonth() + 1) > 9
            ? parseInt(selectedDate.getMonth() + 1)
            : '0' + parseInt(selectedDate.getMonth() + 1);
    var selectedDay =
        parseInt(selectedDate.getDate()) > 9
            ? selectedDate.getDate()
            : '0' + selectedDate.getDate();
    var convertedDateTime =
        selectedYear +
        '-' +
        selectedMonth +
        '-' +
        selectedDay +
        'T09:00:00' +
        convertedDate.substring(19, convertedDate.length);
    return convertedDateTime;
};

export const getDateWithoutTime = (date) => {
    // Considered param date will be as '12/12/1955 12:00 AM'
    let dateWithoutTime;
    try {
        if (!_isEmpty(date)) {
            dateWithoutTime = date.split(' ')[0];
        } else {
            dateWithoutTime = date;
        }
    } catch (e) {
        dateWithoutTime = date;
    }
    return dateWithoutTime;
};

export const convertToGivenFormat = (input) => {
    if (input.toString() == '') return input;
    else {
        const len = input.length;
        const substr = input.substring(0, len - 5) + input.substring(len - 1);
        return substr;
    }
};

export const convertTime24To12hr = (time) => {
    var H = +time.substr(0, 2);
    var h = H % 12 || 12;
    var ampm = H < 12 || H === 24 ? t('common.AM') : t('common.PM');
    return h + time.substr(2, 3) + ampm;
};

export const convertTime12to24hr = (time12h) => {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
        hours = '00';
    }

    if (modifier === 'PM' || modifier === 'pm') {
        hours = parseInt(hours, 10) + 12;
    }

    return `${hours}:${minutes}`;
};
export const convertToISODate = (d, time, userProfileData) => {
    const time24Hr = convertTime12to24hr(time);
    const hr = time24Hr.split(':')[0];
    const min = time24Hr.split(':')[1].split(' ')[0];
    let offset = 'Z';
    if (
        userProfileData &&
        userProfileData.personalUserSettings &&
        userProfileData.personalUserSettings.userInterfaceName &&
        userProfileData.personalUserSettings.userInterfaceName.split(' ')[0]
            .length > 5
    ) {
        offset = userProfileData.personalUserSettings.userInterfaceName
            .split(' ')[0]
            .substring(4, 10);
    }
    const hours = hr.length === 1 ? `0${hr}` : hr;
    const minutes = min.length === 1 ? `0${min}` : min;
    const date = `${d}T${hours}:${minutes}${offset}`;
    d = new Date(date);
    var n = d.toISOString();
    return n;
};
export const activityDurationCalculate = (start, end) => {
    start = new Date(start);
    end = new Date(end);
    var duration = Math.floor((end - start) / (1000 * 60));
    return duration;
    // var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    // var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    // var diff = endDate.getTime() - startDate.getTime();
    // var hours = Math.floor(diff / 1000 / 60 / 60);
    // diff -= hours * 1000 * 60 * 60;
    // var minutes = Math.floor(diff / 1000 / 60);

    // // If using time pickers with 24 hours format, add the below line get exact hours
    // if (hours < 0) {
    //     hours = hours + 24;
    // }
    // let totalHr = (hours <= 9 ? "0" : "") + hours;
    // let activityDuration = '';
    // if (totalHr === '00') {
    //     activityDuration = minutes;
    // } else {
    //     const duration = (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
    //     var hoursMinutes = duration.split(/[.:]/);
    //     var hr = parseInt(hoursMinutes[0], 10);
    //     var min = hoursMinutes[1] ? parseInt(hoursMinutes[1], 10) : 0;
    //     activityDuration = hr + min / 60;
    // }
    // return activityDuration
};

export function isToday(givenDate) {
    try {
        let todaysDate = new Date();
        let ipDate = new Date(givenDate);
        return (
            ipDate.getYear() === todaysDate.getYear() &&
            ipDate.getMonth() === todaysDate.getMonth() &&
            ipDate.getDate() === todaysDate.getDate()
        );
    } catch (e) {
        return false;
    }
}

export function getTwoDigitTimeOnly(givenDate) {
    try {
        let ipDate = new Date(givenDate);
        let ipTimeString = ipDate.toLocaleTimeString();
        let ipTimeArr = ipTimeString.split(':');
        let time;
        if (ipTimeArr[0].length > 1) {
            time = ipTimeArr[0];
        } else {
            time = '0' + ipTimeArr[0];
        }
        if (ipTimeArr[1].length > 1) {
            time = time + ':' + ipTimeArr[1];
        } else {
            time = time + ':' + '0' + ipTimeArr[1];
        }
        let amPM = ipTimeArr[2].split(' ')[1];
        time = time + ' ' + amPM;
        return time;
    } catch (e) {
        return givenDate;
    }
}

export function formatAMPM(ipDate) {
    let strTime;
    try {
        let date = new Date(ipDate);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? t('common.PM') : t('common.AM');
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    } catch (e) {
        logErrorToConsole('Date error', e);
    }
    return strTime;
}

export function getTimeOrDate(ipData) {
    let timeOrDate;
    try {
        if (isToday(ipData)) {
            //timeOrDate= getTwoDigitTimeOnly(ipData);
            timeOrDate = formatAMPM(ipData);
        } else {
            timeOrDate = DateConvertorInMMDDYYYY(ipData);
        }
    } catch (e) {
        timeOrDate = ipData;
    }
    return timeOrDate;
}

const addZero = (time) => {
    if ((time + '').length < 2) {
        return '0' + time;
    }
    return time;
};

export const timeFormatter = (callTime) => {
    const hours = Math.floor(callTime / 60 / 60);

    const minutes = Math.floor(callTime / 60) - hours * 60;

    const seconds = callTime - minutes * 60 - hours * 60 * 60;

    if (hours > 0) {
        return `${hours}:${addZero(minutes)}:${addZero(seconds)}`;
    } else {
        return `${addZero(minutes)}:${addZero(seconds)}`;
    }
};

export const timeFormatterCallLog = (callTime) => {
    const hours = Math.floor(callTime / 60 / 60);

    const minutes = Math.floor(callTime / 60) - hours * 60;

    const seconds = callTime - minutes * 60 - hours * 60 * 60;

    if (hours > 0) {
        return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
        return `${minutes}m ${seconds}s`;
    } else {
        return `${seconds}s`;
    }
};

export function getCurrentUTCTime() {
    var date = new Date();
    try {
        var now_utc = Date.UTC(
            date.getUTCFullYear(),
            date.getUTCMonth(),
            date.getUTCDate(),
            date.getUTCHours(),
            date.getUTCMinutes(),
            date.getUTCSeconds()
        );
        return new Date(now_utc).toISOString().split('.')[0] + 'Z';
    } catch (e) {
        return date;
    }
}

export const notesTimeFormatter = (data, condition) => {
    let hour;
    const a = new Date(data);
    const h = a.getHours();
    const ampm = h >= 12 ? ' pm' : ' am';
    const AMPM = h >= 12 ? t('common.PM') : t('common.AM');
    hour = h % 12;
    hour = hour || 12;
    let min = a.getMinutes();
    min = min.toString().length == 2 ? min : `0${min}`;
    let res;
    if (condition) {
        res = `${hour}:${min}${AMPM}`;
    } else {
        res = `${hour}:${min}${ampm}`;
    }
    return res;
};

export const subtractXdaysFromTodaysDate = (subtractDays) => {
    var date = new Date();
    var last = new Date(date.getTime() - subtractDays * 24 * 60 * 60 * 1000);
    var dt = last.getDate().toString();
    var day = dt && dt.length === 1 ? `0${dt}` : dt;
    var mth = last.getMonth() + 1;
    var mon = mth.toString();
    var month = mon && mon.length === 1 ? `0${mon}` : mon;
    var year = last.getFullYear();
    var date2 = `${year}-${month}-${day}`;
    let result;
    result = DateConvertorInMMDDYYYY(date2);
    return result;
};

export const gmtToLocalDateTime = (userProfileData, targetedDate) => {
    if (targetedDate != null && targetedDate !== undefined && targetedDate) {
        let offset = '';
        let crmFormatedTime = targetedDate;
        if (
            userProfileData &&
            userProfileData.personalUserSettings &&
            userProfileData.personalUserSettings.userInterfaceName &&
            userProfileData.personalUserSettings.userInterfaceName.split(' ')[0]
                .length > 5
        ) {
            let offsetValue =
                userProfileData.personalUserSettings.userInterfaceName
                    .split(' ')[0]
                    .substring(4, 10);
            offset = startsWith(offsetValue, '-')
                ? replace(offsetValue, '-', '+')
                : replace(offsetValue, '+', '-');
        }
        const formatedUserTimezoneDate =
            offset === ''
                ? crmFormatedTime
                : `${replace(crmFormatedTime, 'Z', '')}${offset}`;
        let finalCreatedOn = new Date(formatedUserTimezoneDate).toISOString();
        return finalCreatedOn;
        // console.log("local time",finalCreatedOn,"required format",DateConvertorInMMDDYYYY(finalCreatedOn));
    }
    return null;
};

export const formatDate = (inputDate, pattern) => {
    const date = new Date(inputDate ? inputDate : new Date());
    if (pattern === 'mm/dd/yyyy') {
        return (
            (date.getMonth() > 8
                ? date.getMonth() + 1
                : '0' + (date.getMonth() + 1)) +
            '/' +
            (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
            '/' +
            date.getFullYear()
        );
    }

    var month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
};

export const getDisplayDate = (date, format) => {
    const locale = localStorage.getItem('languageISOCode');
    if (date) {
        // && format !== 'display') {
        return typeof date === 'string'
            ? new Date(date).toLocaleDateString(
                  locale && locale != 'undefined' ? locale : 'en-US'
              )
            : moment(date).format(
                  date?.toLocaleDateString(
                      locale && locale != 'undefined' ? locale : 'en-US'
                  )
              );
    } else if (format === 'display') {
        return moment(date).locale(locale).format('L');
    }

    return '';
};

// Formats a date without applying timezone conversion (no day shift), honoring languageISOCode locale.
// Accepts ISO strings (YYYY-MM-DD, YYYY-MM-DDTHH:mm:ssZ), Date objects, or other parseable strings.
// Returns a localized date-only string; if input is invalid, returns empty string.
export const getDisplayDateNoTZ = (date) => {
    try {
        const locale = localStorage.getItem('languageISOCode');
        const safeLocale = locale && locale !== 'undefined' ? locale : 'en-US';
        if (!date) return '';

        // Prefer ISO-like strings: parse as a pure calendar date, not a timestamp
        if (typeof date === 'string') {
            const isoDateMatch = date.match(/^\d{4}-\d{2}-\d{2}/);
            if (isoDateMatch) {
                // moment will treat 'YYYY-MM-DD' as a date-only without timezone; format by locale
                return moment(isoDateMatch[0], 'YYYY-MM-DD')
                    .locale(safeLocale)
                    .format('L');
            }
            // If it's not ISO, try moment minimal parse; if invalid, try native Date
            const m = moment(date);
            if (m.isValid()) {
                return m.locale(safeLocale).format('L');
            }
            const dt = new Date(date);
            return isNaN(dt) ? '' : dt.toLocaleDateString(safeLocale);
        }

        if (date instanceof Date) {
            return isNaN(date) ? '' : date.toLocaleDateString(safeLocale);
        }

        if (typeof date === 'number') {
            const dt = new Date(date);
            return isNaN(dt) ? '' : dt.toLocaleDateString(safeLocale);
        }

        return '';
    } catch (e) {
        return '';
    }
};

export const getRddDate = (utcDate) => {
    if (!utcDate) return '';
    // Pure calendar date: never apply timezone conversion (would roll the day).
    // An ISO date/datetime string already carries the intended day in its prefix.
    if (typeof utcDate === 'string') {
        const iso = utcDate.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}T00:00:00Z`;
    }
    const date = new Date(utcDate);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
        2,
        '0'
    )}-${String(date.getDate()).padStart(2, '0')}T00:00:00Z`;
};
export const getDisplayDateTime = (date) => {
    const locale = localStorage.getItem('languageISOCode');
    if (date)
        return new Date(date).toLocaleString(
            locale && locale != 'undefined' ? locale : 'en-US',
            {
                month: 'numeric',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
            }
        );
    return '';
};

export const LastDayOfMonth = (Year, Month) => {
    return new Date(new Date(Year, Month, 1) - 1);
};
// export const isCuttOffTime = () => {
//     // const date1 = new Date();
//     const date2 = new Date();
//     date2.setHours(17, 30, 0, 0);
//     if (new Date().getTime() < date2.getTime()) {
//         return true;
//     } else {
//         return false;
//     }
// };

export const getCurrentTime = () => {
    const date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var dueTime = hours + ':' + minutes + ' ' + ampm;
    return dueTime;
};

export const dateTimeZoneHandler = (userProfileData, date) => {
    const convertedDate = gmtToLocalDateTime(userProfileData, date);
    let val = convertedDate;
    let res = '';
    let exactTime = '';
    if (val && val.length > 15) {
        res = val.slice(5, 7) + '/' + val.slice(8, 10) + '/' + val.slice(0, 4);
        var hoursEdit = parseInt(val.slice(11, 13), 10);
        var minutesEdit = val.slice(14, 16);
        var ampm = hoursEdit >= 12 ? 'PM' : 'AM';
        hoursEdit = hoursEdit % 12;
        hoursEdit = hoursEdit ? hoursEdit : 12; // the hour '0' should be '12'
        exactTime = hoursEdit + ':' + minutesEdit + ampm;
    }
    return `${res} ${exactTime}`;
};

export const convertToMMddYYYYDateDashFormat = (data) => {
    const a = new Date(data);
    let dt = a.getDate();
    dt = dt.toString().length == 2 ? dt : `0${dt}`;
    let month = parseInt(a.getMonth()) + 1;
    month = month.toString().length == 2 ? month : `0${month}`;
    const year = a.getFullYear();
    const res = `${month}-${dt}-${year}`;
    return res;
};

export const formatAssignedDate = (data) => {
    const date = new Date(data);
    const year = date.getFullYear();
    const monthNames = [
        t('calendar.months.jan'),
        t('calendar.months.feb'),
        t('calendar.months.mar'),
        t('calendar.months.apr'),
        t('calendar.months.may'),
        t('calendar.months.jun'),
        t('calendar.months.jul'),
        t('calendar.months.aug'),
        t('calendar.months.sep'),
        t('calendar.months.oct'),
        t('calendar.months.nov'),
        t('calendar.months.dec'),
    ];
    const formattedMonth = monthNames[date.getMonth()];
    return `${formattedMonth} ${year}`;
};

export const getEndDateForStartDate = (startDate, noOfDays) => {
    let endDate = new Date(startDate);
    endDate.setDate(startDate.getDate() + noOfDays);
    return new Date(endDate);
};

export const addDaysToDate = (date, days) => {
    let res = new Date(date);
    res.setDate(res.getDate() + days);
    return res;
};

export const getPreviousDate = (date, days) => {
    let res = new Date(date);
    res.setDate(res.getDate() - days);
    return res;
};

export const getNumberOfDaysBetweenTwoDates = (startDate, endDate) => {
    // let timeDifference = endDate.getTime() - startDate.getTime();
    // let daysDifference = timeDifference / (1000 * 60 * 60 * 24);

    const start = moment(startDate);
    const end = moment(endDate);
    return end.diff(start, 'days');
};

/**
 * Normalizes any date input to a local calendar date (midnight in local timezone)
 * without timezone conversion. Handles Date objects, ISO strings, and null values.
 *
 * @param {Date|string|null} dateInput - Date object, ISO string (YYYY-MM-DDTHH:mm:ss.sssZ), or null
 * @returns {Date} Date object set to midnight (00:00:00) in local timezone
 */
export const normalizeToLocalCalendarDate = (dateInput) => {
    if (!dateInput) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    }

    if (typeof dateInput === 'string') {
        // Handle ISO string like "2026-05-24T18:29:59.999Z"
        const datePart = dateInput.split('T')[0];
        const [yearStr, monthStr, dayStr] = datePart.split('-');
        const year = Number(yearStr);
        const month = Number(monthStr);
        const day = Number(dayStr);

        if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
            logErrorToConsole(`Invalid date string format: ${dateInput}`);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return today;
        }

        return new Date(year, month - 1, day, 0, 0, 0, 0);
    }

    if (dateInput instanceof Date) {
        const normalized = new Date(
            dateInput.getFullYear(),
            dateInput.getMonth(),
            dateInput.getDate(),
            0,
            0,
            0,
            0
        );
        return normalized;
    }

    // Fallback for invalid input types
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return today;
};

export const getEndOfTimeDate = () => {
    return '';
};

export const getBrowserTimeZoneName = () => {
    return moment.tz
        .zone(moment.tz.guess())
        .abbr(new Date().getTimezoneOffset());
};

export const excludesWeekendsForSurgeryDate = () => {
    const currentDay = new Date().getDay();
    let minDate;

    if (currentDay == 0) {
        // Exclude 1 day for Sunday
        minDate = new Date(moment().subtract(4, 'd'));
    } else if (currentDay == 1 || currentDay == 2 || currentDay == 3) {
        // Exclude 2 days for Monday
        minDate = new Date(moment().subtract(5, 'd'));
    } else if (currentDay == 4 || currentDay == 5 || currentDay == 6) {
        // no exclusion for Thursday, friday, Saturday
        minDate = new Date(moment().subtract(3, 'd'));
    }

    return minDate;
};

export const getWeekendCountBetweenDates = (startDate, endDate) => {
    let totalWeekends = 0;
    for (let i = startDate; i <= endDate; i.setDate(i.getDate() + 1)) {
        if (i.getDay() == 0 || i.getDay() == 6) totalWeekends++;
    }
    if (endDate.getDay() == 0) totalWeekends++;
    return totalWeekends;
};

export const getTimeZoneName = () => {
    return moment.tz
        .zone(moment.tz.guess())
        .abbr(new Date().getTimezoneOffset());
};

export const checkIfDateIsNonBusinessDay = (
    dateObject,
    listOfHolidaysInMillisecondsToExclude
) => {
    return (
        dateObject.getDay() === 0 ||
        dateObject.getDay() === 6 ||
        listOfHolidaysInMillisecondsToExclude?.includes(dateObject.valueOf())
    );
};

export const getListOfLastThreeBusinessDays = (
    dateObject, //initially yesterday's date object
    arrayOfDates, //initially pass an empty array
    listOfHolidaysInMillisecondsToExclude
) => {
    if (
        checkIfDateIsNonBusinessDay(
            dateObject,
            listOfHolidaysInMillisecondsToExclude
        )
    ) {
        return getListOfLastThreeBusinessDays(
            moment(dateObject).startOf('day').subtract(1, 'days').toDate(),
            arrayOfDates,
            listOfHolidaysInMillisecondsToExclude
        );
    } else if (arrayOfDates?.length < 3) {
        let newArrayOfDates = [...arrayOfDates, dateObject.valueOf()];
        return getListOfLastThreeBusinessDays(
            moment(dateObject).startOf('day').subtract(1, 'days').toDate(),
            newArrayOfDates,
            listOfHolidaysInMillisecondsToExclude
        );
    }
    //storing past Three Business Days (consist holidays, weekends) in localstorage to use these values in schedule surgery
    localStorage.setItem('businessDays', arrayOfDates.sort());
    return arrayOfDates.sort();
};

//getting the dates which are not allowed to Select Requested Delivery Date.
export const getListOfDatesForLeadTimeLogic = (
    dateObject, // initially tomorrow's date object
    listOfHolidaysInMillisecondsToExclude,
    LeadTime = 2,
    consignmentAdd
) => {
    const alertDatesforDeliveryDate = [];
    let businessDayCount = 0;
    let currentDate = moment(dateObject).toDate();

    while (businessDayCount < parseInt(LeadTime)) {
        if (
            !checkIfDateIsNonBusinessDay(
                currentDate,
                listOfHolidaysInMillisecondsToExclude
            )
        ) {
            alertDatesforDeliveryDate.push(currentDate.valueOf());
            businessDayCount++;
            currentDate = moment(currentDate)
                .startOf('day')
                .add(1, 'days')
                .toDate();
        } else {
            alertDatesforDeliveryDate.push(currentDate.valueOf());
            currentDate = moment(currentDate)
                .startOf('day')
                .add(1, 'days')
                .toDate();
        }
    }
    // storing the array in localStorage
    if (consignmentAdd === 'kb') {
        localStorage.setItem(
            'alertDatesforConsignmentAdd',
            alertDatesforDeliveryDate.sort()
        );

        return alertDatesforDeliveryDate.sort();
    } else {
        localStorage.setItem(
            'alertDatesforDeliveryDate',
            alertDatesforDeliveryDate.sort()
        );

        return alertDatesforDeliveryDate.sort();
    }
};

export const getPlaceholderDateFormat = () => {
    if (moment(getDisplayDate(new Date()), 'DD/MM/YYYY', true).isValid())
        return 'DD/MM/YYYY';
    if (moment(getDisplayDate(new Date()), 'D/MM/YYYY', true).isValid())
        return 'DD/MM/YYYY';
    if (moment(getDisplayDate(new Date()), 'DD/M/YYYY', true).isValid())
        return 'DD/MM/YYYY';
    if (moment(getDisplayDate(new Date()), 'D/M/YYYY', true).isValid())
        return 'DD/MM/YYYY';
    if (moment(getDisplayDate(new Date()), 'MM/DD/YYYY', true).isValid())
        return 'MM/DD/YYYY';
    if (moment(getDisplayDate(new Date()), 'M/DD/YYYY', true).isValid())
        return 'MM/DD/YYYY';
    if (moment(getDisplayDate(new Date()), 'MM/D/YYYY', true).isValid())
        return 'MM/DD/YYYY';
    if (moment(getDisplayDate(new Date()), 'M/D/YYYY', true).isValid())
        return 'MM/DD/YYYY';
    if (moment(getDisplayDate(new Date()), 'MM-DD-YYYY', true).isValid())
        return 'MM-DD-YYYY';
    if (moment(getDisplayDate(new Date()), 'DD-MM-YYYY', true).isValid())
        return 'DD-MM-YYYY';
    if (moment(getDisplayDate(new Date()), 'DD-M-YYYY', true).isValid())
        return 'DD-MM-YYYY';
    if (moment(getDisplayDate(new Date()), 'D-M-YYYY', true).isValid())
        return 'DD-MM-YYYY';
    if (moment(getDisplayDate(new Date()), 'DD.MM.YYYY', true).isValid())
        return 'DD.MM.YYYY';
    if (moment(getDisplayDate(new Date()), 'DD.M.YYYY', true).isValid())
        return 'DD.MM.YYYY';
    if (moment(getDisplayDate(new Date()), 'D.M.YYYY', true).isValid())
        return 'DD.MM.YYYY';
    if (moment(getDisplayDate(new Date()), 'MM.DD.YYYY', true).isValid())
        return 'MM.DD.YYYY';
    if (moment(getDisplayDate(new Date()), 'YYYY/MM/DD', true).isValid())
        return 'YYYY/MM/DD';
    if (moment(getDisplayDate(new Date()), 'YYYY/M/DD', true).isValid())
        return 'YYYY/M/DD';
    if (moment(getDisplayDate(new Date()), 'YYYY/M/D', true).isValid())
        return 'YYYY/M/D';
    if (moment(getDisplayDate(new Date()), 'YYYY/MM/D', true).isValid())
        return 'YYYY/MM/D';
};

export const getCurrentCSTTime = () => {
    const date = new Date();
    var CSToffSet = (isCdtOrCst() ? -300 : -360) + date.getTimezoneOffset(); //CST is -6:00 of UTC; i.e. 60*6 = -360 in minutes
    var offset = CSToffSet * 60 * 1000;
    var CSTTime = new Date(date.getTime() + offset);
    var hours = CSTTime.getHours();
    var minutes = CSTTime.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    var currentCSTTime = hours + ':' + minutes + ' ' + ampm;

    return currentCSTTime;
};

export const isCdtOrCst = () => {
    const gmtDate = new Date();

    // Create a date formatter with the Central Time Zone
    const cdtFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Chicago',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        timeZoneName: 'short',
    });

    // Format the GMT date in CDT
    const cdtDateString = cdtFormatter.format(gmtDate);

    // Determine if the current time zone is CDT or CST
    if (cdtDateString.includes('CDT')) {
        return true;
    } else if (cdtDateString.includes('CST')) {
        return false;
    } else {
        logErrorToConsole('Unknown time zone');
    }
};
//give currentTime based on country code
export const getCurrentTimeByCountryCode = (countryCode, includeDate) => {
    const now = new Date();

    const timeZoneMap = {
        JP: 'Asia/Tokyo',
        US: 'America/New_York',
    };

    const timeZone = timeZoneMap[countryCode] || 'UTC';

    // Use toLocaleString to format the date and time properly
    const options = {
        timeZone,
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // 24-hour format
    };

    if (includeDate) {
        return now.toLocaleString('en-US', options) + ' JST'; // Append 'JST' for Japan time
    } else {
        // Options for time only
        const timeOptions = {
            timeZone,
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        };
        return new Intl.DateTimeFormat('en-US', timeOptions).format(now);
    }
};
// export const isDateAvailableInJapan = (selectedDate, timezone) => {
//     const localDate = new Date(selectedDate);

//     const currentDateTime = convertDateFormat(
//         getCurrentDateTimeByTimeZone(timezone)
//     );
//     const date = currentDateTime.split(',');
//     const zone = date[1].trim();
//     const time = zone.split(' ');
//     const japanDate = new Date(date[0]);

//     const normalizedJapanDate = new Date(japanDate.setHours(0, 0, 0, 0));

//     return checkDateAndSampleTime(normalizedJapanDate, time[0]);
// };
export const getCurrentDateTimeByTimeZone = (timezone) => {
    // Get the current date and time in the specified timezone

    // Create a formatter for the given timezone
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: 'numeric', //24 hrs
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
        timeZoneName: 'short',
    });

    let formattedDate = formatter.format(new Date());

    const parts = formattedDate.split(' ');
    parts[parts.length - 1] = timezone;
    return parts.join(' ');
};
export const isTimeBefore1730JST = (dateString) => {
    // Parse the passed date string into a Date object
    const date = new Date(dateString);

    if (isNaN(date)) {
        return false;
    }

    // Create a Date object for 17:30 JST on the same day
    const compareDate = new Date(date);
    compareDate.setHours(17, 30, 0, 0); // Set time to 17:30:00 JST

    // Check if the passed time is before 17:30 JST
    return date < compareDate;
};

export const convertDateFormat = (dateString) => {
    // Step 1: Remove the timezone abbreviation (like JST) and replace with the GMT+0900 offset
    const cleanedDateString = dateString.replace('JST', 'GMT+0900');

    // Step 2: Parse the cleaned string into a Date object
    const dateObject = new Date(cleanedDateString);

    // Step 3: Check if the parsed date is valid
    if (isNaN(dateObject)) {
        return 'Invalid date format!';
    }

    // Step 4: Format the date as desired
    const options = {
        year: 'numeric',
        month: '2-digit', // 2-digit month
        day: '2-digit', // 2-digit day
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'Asia/Tokyo',
        hour12: false, // 24-hour format
    };

    // Use toLocaleString to format the date
    const formattedDate = dateObject.toLocaleString('en-US', options);

    // Step 5: Return the formatted string with JST
    return formattedDate + ' JST';
};

export const getMinimumDatesBasedOnJapanTime = (
    localDate,
    cutOffTime,
    accountId
) => {
    const userTimeObj = new Date(localDate);
    userTimeObj.setHours(0, 0, 0, 0);
    const cut_Off_Time = cutOffTime ? cutOffTime.split(':') : [25, 25];
    const cutOffHours = parseInt(cut_Off_Time[0]);
    const cutOffMinutes = parseInt(cut_Off_Time[1]);
    const accountOffset = accountId?.timeZoneOffset;
    const accountTimeZone = accountId?.accountTimeZone;

    const japanTime = getJapanCurrentDateTime(
        accountOffset,
        accountTimeZone,
        false
    );
    const [year, month, day] = japanTime.formattedDate.split('-').map(Number);
    const [japanHours, japanMinutes] = japanTime.formattedTime
        .split(':')
        .map(Number);

    const japanDate = new Date(year, month - 1, day);
    japanDate.setHours(0, 0, 0, 0);

    const hasJapanCrossed530 =
        cutOffHours !== 25
            ? japanHours > cutOffHours ||
              (japanHours === cutOffHours && japanMinutes >= cutOffMinutes)
            : false;
    const resultDates = [];
    const isGreaterThanJapanDate = userTimeObj > japanDate;
    const isSameDate = userTimeObj.toDateString() === japanDate.toDateString();
    if (isGreaterThanJapanDate) {
        // Local date is greater than Japan's current date
        resultDates.push(
            hasJapanCrossed530
                ? new Date(
                      japanDate.setDate(japanDate.getDate() + 1)
                  ).toDateString()
                : japanDate.toDateString()
        );
    } else if (isSameDate) {
        resultDates.push(
            hasJapanCrossed530
                ? new Date(
                      japanDate.setDate(japanDate.getDate() + 1)
                  ).toDateString()
                : japanDate.toDateString()
        );
        // resultDates.push(new Date(japanDate.toDateString()));
    } else {
        resultDates.push(
            hasJapanCrossed530
                ? new Date(
                      japanDate.setDate(japanDate.getDate() + 1)
                  ).toDateString()
                : japanDate.toDateString()
        );
    }

    return resultDates.length > 0 ? resultDates : '';
};

export const getJapanCurrentDateTime = (japanOffset, zone, date = false) => {
    const currentTime = new Date(
        new Date().getTime() + japanOffset * 60 * 1000
    );

    // Format date as YYYY-MM-DD
    const year = currentTime.getUTCFullYear();
    const month = String(currentTime.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(currentTime.getUTCDate()).padStart(2, '0');

    const hours = String(currentTime.getUTCHours()).padStart(2, '0');
    const minutes = String(currentTime.getUTCMinutes()).padStart(2, '0');

    const formattedDate = `${year}-${month}-${day}`;
    const formattedTime = `${hours}:${minutes}`;
    if (date) {
        const date = `${year}/${month}/${day} ${hours}:${minutes} ${zone}`;
        return date;
    }
    return { formattedDate, formattedTime };
};

export const getDisabledDatesBasedOnJapanTime = (
    localDate,
    sameDay = false,
    cutOffTime,
    accountId
) => {
    const userTimeObj = new Date(localDate);
    userTimeObj.setHours(0, 0, 0, 0);
    const accountOffset = accountId?.timeZoneOffset;
    const accountTimeZone = accountId?.accountTimeZone;
    const cut_Off_Time = cutOffTime ? cutOffTime.split(':') : [25, 25];
    const cutOffHours = parseInt(cut_Off_Time[0]);
    const cutOffMinutes = parseInt(cut_Off_Time[1]);
    const japanTime = getJapanCurrentDateTime(
        accountOffset,
        accountTimeZone,
        false
    );
    const [year, month, day] = japanTime.formattedDate.split('-').map(Number);
    const [japanHours, japanMinutes] = japanTime.formattedTime
        .split(':')
        .map(Number);

    const japanDate = new Date(year, month - 1, day);
    japanDate.setHours(0, 0, 0, 0);

    const hasJapanCrossed530 =
        cutOffHours !== 25
            ? japanHours > cutOffHours ||
              (japanHours === cutOffHours && japanMinutes >= cutOffMinutes)
            : false;
    const resultDates = [];

    const isBeforeJapanDate = userTimeObj < japanDate;
    const isSameDate = userTimeObj.toDateString() === japanDate.toDateString();

    if (!sameDay && hasJapanCrossed530) {
        if (isBeforeJapanDate) {
            let currentDate = new Date(userTimeObj);
            while (currentDate <= japanDate) {
                resultDates.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }
        } else if (isSameDate) {
            resultDates.push(new Date(userTimeObj));
        }
    } else if (!sameDay && !hasJapanCrossed530) {
        if (isBeforeJapanDate) {
            let currentDate = new Date(userTimeObj);
            while (currentDate < japanDate) {
                resultDates.push(new Date(currentDate));
                currentDate.setDate(currentDate.getDate() + 1);
            }
        }
    }

    // If sameDay is true
    if (sameDay && isSameDate) {
        if (hasJapanCrossed530) {
            resultDates.push(new Date(userTimeObj));
        } else {
            return '';
        }
    } else if (sameDay && isBeforeJapanDate) {
        resultDates.push(new Date(userTimeObj));
    } else if (sameDay && !isSameDate && !isBeforeJapanDate) {
        // if (hasJapanCrossed530) {
        // resultDates.push(new Date(userTimeObj));
        // let currentDate = new Date(userTimeObj);
        // const next = new Date(japanDate);
        // next.setDate(next.getDate() + 1);
        // next.setHours(0, 0, 0, 0);
        // const currentDate = new Date();
        // currentDate.setHours(0, 0, 0, 0);
        // currentDate.setDate(next.getDate() + 1);
        // // currentDate.setHours(0, 0, 0, 0);
        // if (userTimeObj.toDateString() === next.toDateString()) {
        //     resultDates.push(new Date(userTimeObj));
        // } else {
        return '';
        // }
    } else {
        return '';
    }

    return resultDates.length > 0 ? resultDates : '';
};

export const formatDateddmmmyy = (
    dateString,
    countryCode = null,
    fromNote = false
) => {
    const date = new Date(dateString);

    const options = { day: '2-digit', month: 'short', year: '2-digit' };
    return countryCode === 'JP'
        ? date.toLocaleDateString('ja-JP')
        : countryCode === 'US'
        ? date.toLocaleDateString('en-US')
        : fromNote
        ? date.toLocaleDateString('en-GB')
        : date.toLocaleDateString('en-GB', options).replace(/ /g, '-');
};

export const formatDateToMMDDYY = (dateStr) => {
      if (!dateStr) return null;
      let date;
      if (dateStr instanceof Date) {
        date = dateStr;
      } else {
        const str = String(dateStr);
        // Extract just the date part (YYYY-MM-DD) and build local date
        const [datePart] = str.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        date = new Date(year, month - 1, day);
      }
      if (isNaN(date.getTime())) return String(dateStr);
      return `${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}/${String(date.getFullYear()).slice(-2)}`;
  };

export const convertToISODateFormat = (dateString) => {
    // Check if the date is in yyyy/MM/dd format
    const regex = /^\d{4}\/\d{2}\/\d{2}$/;

    if (regex.test(dateString)) {
        // Replace '/' with '-' and append "T00:00:00Z" for ISO format
        return dateString.replace(/\//g, '-') + 'T00:00:00Z';
    }

    return 'Invalid date format';
};

// Format ISO date string to mm/dd/yy
export const formatModalDate = (dateString, isJapan = false) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear());
    return isJapan ? `${year}/${month}/${day}` : `${month}/${day}/${year}`;
};

export const isStartDateLessThanEndDate = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);

    return endDate === '' ? true : start < end;
};

// Format date as "MM/DD/YYYY at HH:MM (timezone)" for last refresh messages
export const formatLastRefreshDateTime = (date) => {
    if (!date) return '';
    
    const formattedDate = changeDateFormat(date);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const timezone = getBrowserTimeZoneName();
    
    return `${formattedDate} at ${hours}:${minutes} (${timezone})`;
};

export const formatDateTimeForQR = () => {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${month}/${day}/${year}/${hours}:${minutes}:${seconds}`;
};
